export default __webpack_public_path__ + "static/media/video_game_cabinet_small_square.4bce7950.png";